<template>
  <div
    ref="container"
    v-infinite-scroll="loadMoreItems"
    :infinite-scroll-disabled="!hasMoreData || !isVisible"
    :infinite-scroll-distance="10"
  >
    <slot :items="visibleItems"></slot>
  </div>
</template>

<script>
export default {
  name: "LazyList",
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    objectItems: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    hasMoreData: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isVisible: false,
      observer: null,
    };
  },
  computed: {
    visibleItems() {
      if (this.items.length > 0) {
        return this.items;
      }

      if (Object.keys(this.objectItems).length > 0) {
        return Object.keys(this.objectItems).map((key) => ({
          date: key,
          items: this.objectItems[key],
        }));
      }

      return [];
    },
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  beforeDestroy() {
    this.cleanupIntersectionObserver();
  },
  methods: {
    loadMoreItems() {
      if (this.isVisible) {
        this.$emit("load-more");
      }
    },
    setupIntersectionObserver() {
      if (!this.$refs.container) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
          });
        },
        {
          threshold: 0,
          rootMargin: '10px',
        }
      );

      this.observer.observe(this.$refs.container);
    },
    cleanupIntersectionObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
  },
};
</script>
